export enum ONE_TIME_KEYS {
    ID_CREATED_WITH_RELOAD = 'id_created_with_reload',
}

export const getOneTimeValue = (key: ONE_TIME_KEYS): Maybe<string | null> => {
    const value = global.window?.sessionStorage.getItem(key);
    global.window?.sessionStorage.removeItem(key);

    return value;
};

export const setOneTimeValue = (key: ONE_TIME_KEYS, value: string): void => {
    global.window?.sessionStorage.setItem(key, value);
};
